import React, { useState } from 'react';
import { connect } from "react-redux";

import DotMeterianFile from "../../classes/dotmeterian";
import { Navigator } from './report_components'

const $ = window.$

let hasTitleBeenRendered = false;
let processedUrl = ""
let previouslySticky = false

const TitleRow = (props) => {
    const { titleState, title, url, reportReady } = props
    const { exclusions } = props.report
    const [isLinkAvailable, setLinkState] = useState(false);
    const [isSticky, setSticky] = useState(previouslySticky)
    const display = title && title.length && Object.keys(titleState).length > 0 && reportReady;
    if (!display) return ""
    if (!hasTitleBeenRendered) {
        hasTitleBeenRendered = true;
        processedUrl = processUrl(url)
        verifyUrl(processedUrl)
            .then(result => {
                setLinkState(result);
            })

    }
    const hasExclusions = exclusions ? Object.keys(exclusions).length > 0 : false
    const isGithubProject = url.includes("github.com");


    const render = () => {
        if (!display) return null
        return <Title>
            <div className="col-lg-7 d-flex flex-column justify-content-end">

                <Link
                    title={props.title}
                    isLatestReport={props.isLatestReport}
                    openDependenciesTree={props.openDependenciesTree}
                    displayBranches={props.displayBranches}
                    selectedBranch={props.selectedBranch}
                    branches={props.branches}
                    urlParams={props.urlParams}
                    loadPage={props.loadPage}
                    isLinkAvailable={isLinkAvailable}
                    processedUrl={processedUrl}
                />
            </div>
            <div className="col-lg-5 text-right">
                <Actions
                    hasError={props.hasError}
                    isLatestReport={props.isLatestReport}
                    componentsCount={props.componentsCount}
                    downloadKey={props.downloadKey}
                    recompute={props.recompute}
                    reportTimestamp={props.reportTimestamp}
                    reportExclusions={props.reportExclusions}
                    refreshDialog={props.refreshDialog}
                    readonly={props.readonly}
                    pid={props.urlParams.pid}
                    branch={props.urlParams.branch}
                    isPublic={props.titleState.isPublic}
                    hasSbom={props.titleState.canDownloadSbom}
                    recomputeReminderState={props.recomputeReminderState}
                    isDownloadAvailable={props.titleState.isDownloadAvailable}
                    isAccountOpensource={props.titleState.isAccountOpensource}
                    canDownloadPDF={props.titleState.canDownloadPDF}
                    projectsController={props.projectsController}
                    hasExclusions={hasExclusions}
                    isLinkAvailable={isLinkAvailable}
                    isGithubProject={isGithubProject}
                />
                <Badges hasError={props.hasError}
                />
            </div>
        </Title>
    }

    const Title = (props) => (
        isSticky ? <TitleSticky>
            {props.children}
        </TitleSticky> :
            <TitleFixed>
                {props.children}
            </TitleFixed>
    )

    const TitleFixed = (props) => {
        return (<div className="row title-row pt-5 pb-2" id="report-title">
            {props.children}
        </div>)
    }

    const TitleSticky = (props) => {
        return (<div className="w-100 position-fixed container report-container title-row-sticky-wrapper " onMouseLeave={(e) => showMenuIfOutOfBounds(e)}>
            <div className="row title-row title-row-sticky" id="report-title">
                {props.children}
            </div>
        </div>)
    }

    function isTouchDevice() {
        return "ontouchstart" in window;
    }

    if (!isTouchDevice()) {
        window.$(window).on("scroll", () => {
            if (window.scrollY > window.$(".navbar").height() + 50) {
                previouslySticky = true
                setSticky(true)
                return
            }
            else {
                previouslySticky = false
                setSticky(false)
                return
            }
        })
    }
    const showMenuIfOutOfBounds = (e) => {

        const isOutOfBounds = e.nativeEvent.y < 0

        if (isOutOfBounds) {
            $(".title-row-sticky-wrapper").addClass("hover")
        }
    }

    window.$(window).on("mouseover", (e) => {
        $(".title-row-sticky-wrapper").removeClass("hover")
    })


    return render()

}

const Link = ({ title, isLinkAvailable, processedUrl, isLatestReport, openDependenciesTree, displayBranches, selectedBranch, branches, urlParams, loadPage }) => {
    const processedTitle = window.splitName(title.replace("//", ""))
    return <>
        <div className="report-title">
            <div title={title} className="project-name"><div className="project-front-name">{processedTitle[0]}</div><div className="project-tail-name">{processedTitle[1]}</div></div>
            {isLinkAvailable ? <a href={`${processedUrl}`} className="btn btn-link" target="_blank" rel="noopener noreferrer" aria-hidden="true"><i className="fa fa-external-link"></i></a> : null}&nbsp;
            {isLatestReport ? <span className="btn btn-link pointer d-none d-sm-inline text-nowrap"
                tabIndex={0}
                onClick={() => openDependenciesTree()}
                onKeyUp={(e) => { if (e.key.toLowerCase() != "enter") return; openDependenciesTree() }}>Show dependencies tree</span> : null}&nbsp;
        </div>
        <p>
            <Branch display={displayBranches} isLatestReport={isLatestReport} selectedBranch={selectedBranch} branches={branches} urlParams={urlParams} />
            <Navigator loadPage={loadPage} />
        </p>
    </>

}

const Branch = ({ display, selectedBranch, branches, urlParams, isLatestReport }) => {

    const changeBranch = (branch, urlParams) => {
        const generateNewUrl = () => {
            let path = window.location.origin + window.location.pathname;
            const query = []
            for (const key in urlParams) {
                const param = key === "branch" ? branch : urlParams[key];
                query.push(key + "=" + param);
            }
            return path + "?" + query.join("&");
        }
        if (window.dependencyTree) {
            window.dependencyTree.close()
        }
        const newUrl = generateNewUrl();
        window.location.replace(newUrl);
    }

    const BranchesList = ({ branches }) => {
        const branchesSelect = branches.map(branch =>
            <option tabIndex={-1} key={branch} value={branch}>
                {branch}
            </option>
        )
        setTimeout(() => {
            $("#branches-dropdown").selectpicker()
            $("button[data-id='branches-dropdown']").attr("tabindex", "0").on("focusin", () => {
                setTimeout(() => {
                    $("button[data-id='branches-dropdown']").attr("tabindex", "0")
                }, 500)
            }).on("blur", () => {
                setTimeout(() => {
                    $("button[data-id='branches-dropdown']").attr("tabindex", "0")
                }, 500)
            })
        }, 500);
        return branchesSelect
    }

    return (
        display ?
            <React.Fragment>
                <span className="mt-1">Branch:
                    {!isLatestReport ? <b className='ml-2 mr-2'>{selectedBranch}</b> : null}
                </span>

                {isLatestReport ? <select tabIndex={-1} className="selectpicker" style={{ marginTop: "-4px" }} data-live-search="true" id="branches-dropdown"
                    onChange={(e) => changeBranch(e.target.value, urlParams)} value={decodeURIComponent(selectedBranch)}
                    aria-label="project branch selector"
                >
                    <BranchesList branches={branches} />
                </select> : null}
                &nbsp;&nbsp;&nbsp;&nbsp;
            </React.Fragment>
            : null
    )
}




const Actions = ({ hasError, isDownloadAvailable, isLatestReport,
    componentsCount, pid, branch, downloadKey, isPublic, hasSbom,
    isAccountOpensource, canDownloadPDF, reportExclusions,
    hasExclusions, isLinkAvailable, isGithubProject,
    refreshDialog, readonly, recomputeReminderState, projectsController, recompute,
    reportTimestamp }) => {


    const generateDownloadTimeout = () => {
        // return Math.trunc(Math.ceil((componentsCount * 30) / 60))
        return 99999999999999999
    }
    const generateDownloadRefreshTime = () => {
        return Math.ceil(componentsCount / 200)
    }

    const doDownload = async (item, format, key, altItem) => {
        if (key && key.toLowerCase() != "enter") return;
        const requestId = await projectsController.reports.generateDownloadContent(altItem || item, pid, branch)
        if (!requestId) return
        const maxTimeout = generateDownloadTimeout()
        const refreshEvery = generateDownloadRefreshTime()
        const url = `/processing_request.html?source=report&type=${format}&key=${downloadKey}&resource=${encodeURIComponent(requestId)}&pid=${pid}&branch=${branch}&timeout=${maxTimeout * 1000}&refreshTimer=${refreshEvery * 1000}`
        window.open(url, "_blank", "noopener noreferrer")
    }

    const Download = () => {
        const render = () => {
            if (hasError || !isDownloadAvailable || !isLatestReport) return null
            return <div id="dnload-button" className="d-inline-block mr-1">
                <Report />
                <Dropdown />
            </div>
        }
        const Report = () => {

            return canDownloadPDF ?
                <span tabIndex={-1} id="dnload-report-pdf" target="_blank" rel="noopener noreferrer"
                    onClick={() => doDownload("report", "pdf", null, "bible")}
                    onKeyUp={(e) => { doDownload("report", "pdf", e.key, "bible") }}
                >
                    <button className="btn btn-primary btn-xs btn-left">Download Report PDF</button>
                </span> :
                <a tabIndex={-1} id="dnload-report-json" className="mr-1" target="_blank" rel="noopener noreferrer" href={`/api/v1/reports/${pid}/json?branch=${branch}&key=${downloadKey}`}>
                    <button className="btn btn-primary btn-xs btn-left">Download Report JSON</button>
                </a>
        }

        const LicensesBible = () => (
            !isPublic && hasSbom && !isAccountOpensource ?
                <React.Fragment>
                    <div className="dropdown-divider"></div>
                    <span id="dnload-bible-pdf" className="dropdown-item pointer"
                        tabIndex={0}
                        onClick={() => doDownload("bible", "bible_pdf")}
                        onKeyUp={(e) => { doDownload("bible", "bible_pdf", e.key) }}
                    >Licenses Bible PDF</span>

                    <span id="dnload-bible-json" className="dropdown-item pointer"
                        tabIndex={0}
                        onClick={() => doDownload("bible", "bible_json")}
                        onKeyUp={(e) => { doDownload("bible", "bible_json", e.key) }}
                    >Licenses Bible JSON</span>

                    <div className="dropdown-divider"></div>
                    <span id="dnload-bible-csv" className="dropdown-item pointer"
                        tabIndex={0}
                        onClick={() => doDownload("bible", "sbom_csv")}
                        onKeyUp={(e) => { doDownload("bible", "sbom_csv", e.key) }}
                    >Bill of Materials CSV</span>

                    <span id="dnload-bible-cdxjson" className="dropdown-item pointer"
                        tabIndex={0}
                        onClick={() => doDownload("bible", "sbom-cdx.json")}
                        onKeyUp={(e) => { doDownload("bible", "sbom-cdx.json", e.key) }}
                    >Bill of Materials CyclonDX/JSON</span>

                    <span id="dnload-bible-cdxxml" className="dropdown-item pointer"
                        tabIndex={0}
                        onClick={() => doDownload("bible", "sbom-cdx.xml")}
                        onKeyUp={(e) => { doDownload("bible", "sbom-cdx.xml", e.key) }}
                    >Bill of Materials CyclonDX/XML</span>

                </React.Fragment>
                : ""
        )

        const Dropdown = () => (
            canDownloadPDF ?
                <React.Fragment>
                    <button id="dnload-other" type="button" className="btn btn-primary btn-xs dropdown-toggle dropdown-toggle-split btn-right" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right mr-1">
                        <a id="dnload-report-json" className="dropdown-item" target="_blank" rel="noopener noreferrer" href={`/api/v1/reports/${pid}/json?branch=${branch}&key=${downloadKey}`}>Report JSON</a>
                        <LicensesBible />
                    </div>
                </React.Fragment> : ""
        )


        return render()
    }

    const dotMeterianFile = "data: text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(DotMeterianFile(reportExclusions), null, "  "));
    const dotMeterianFileFull = "data: text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(DotMeterianFile(reportExclusions, true), null, "  "));
    let timestamp = Date.now()
    try {
        const { dayOfMonth, monthValue, year, hour, minute, second, nano } = reportTimestamp
        timestamp = `${dayOfMonth}.${monthValue}.${year}-${hour}.${minute}.${second}.${nano}`
    }
    catch (e) { }

    const DotMeterian = () => (hasExclusions && !isPublic && isLatestReport ?
        <div id="download-exclusions">
            <a id="dot-meterian-button" className="btn btn-primary btn-xs btn-left" href={dotMeterianFile} download=".meterian" target="_blank" rel="noopener noreferrer">Download Exclusions</a>
            <React.Fragment>
                <button id="download-exclusions-dropdown" type="button" className="btn btn-primary btn-xs dropdown-toggle dropdown-toggle-split btn-right" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="sr-only">Toggle Dropdown</span>
                </button>
                <div className="dropdown-menu dropdown-menu-right mr-1">
                    <a id="dot-meterian-button" className="dropdown-item" href={dotMeterianFileFull} download=".meterian" target="_blank" rel="noopener noreferrer">Download Full Exclusions</a>
                </div>
            </React.Fragment>
        </div>
        :
        null)




    const Refresh = () => (isLinkAvailable && isGithubProject && isLatestReport ? <button id="refresh-button" className="btn btn-primary btn-xs" onClick={refreshDialog}>Refresh Report</button> : null)
    const Recompute = () => (!isPublic && !readonly && isLatestReport ? <button id="recompute-button" data-timestamp={timestamp} className={"btn btn-primary btn-xs" + (recomputeReminderState ? " recompute-glow" : "")} onClick={async () => await recompute()}>Recompute Report</button> : null)


    return (
        <div className="p-spacing">
            <DotMeterian />
            <Download />
            <Refresh />
            <Recompute />
        </div>
    )
}

const BadgesComponent = ({ badges, hasError }) => {

    const Security = () => (badges.security.ready && badges.security.badge ? <a href="#defects-row">
        <img title="In regards of vulnerabilities of linked libraries, how secure is your software from 0 to 100?" id="badge-security" className="larger-badge" src={badges.security.badge} alt="Security Score Badge" />
    </a> : ""
    )
    const Stability = () => (badges.stability.ready && badges.stability.badge ? <a href="#versions-row">
        <img title="How much is your software up-to-date with the latest version of the libraries you are using, from 0 to 100?" id="badge-stability" className="larger-badge" src={badges.stability.badge} alt="Stability Score Badge" />
    </a> : ""
    )
    const Licensing = () => (badges.licensing.ready && badges.licensing.badge ?
        <a href="#licenses-row">
            <img title="How much is your company at legal risk because of any forbidden licenses, from 0 to 100?" id="badge-licensing" className="larger-badge" src={badges.licensing.badge} alt="Licensing Score Badge" />
        </a>
        : null
    )

    return (
        !badges || hasError ? "" :
            <p>
                <Security />
                <Stability />
                <Licensing />
            </p>
    )

}

const mapBadgesStateAsProps = state => {
    const badgeState = {
        badges: {
            security: {
                ready: !!state.projectInfo.badges.securityBadge,
                badge: state.projectInfo.badges.securityBadge
            },
            stability: {
                ready: !!state.projectInfo.badges.stabilityBadge,
                badge: state.projectInfo.badges.stabilityBadge
            },
            licensing: {
                ready: !!state.projectInfo.badges.licensingBadge,
                badge: state.projectInfo.badges.licensingBadge
            },
            ready: !!state.projectInfo.badges.securityBadge || !!state.projectInfo.badges.stabilityBadge || !!state.projectInfo.badges.licensingBadge
        }
    }
    return badgeState
}

const Badges = connect(mapBadgesStateAsProps)(BadgesComponent)

const processUrl = (url) => {
    url = url.split("?")[0];
    const howMainProviders = url.split(":").length - 1
    if (howMainProviders > 1) {
        url = url.split(":")
        url.shift()
        url = url.join(":")
    }
    url = url.replace("github:", "github.com/")
        .replace("gitlab:", "gitlab.com/")
        .replace("bitbucket:", "bitbucket.org/")
        .replace("docker:", "hub.docker.com/r/");

    if (!url.includes("http") && !url.includes("https")) {
        if (url.includes("//")) url = "https:" + url;
        else url = "https://" + url;
    }
    return url
}
const verifyUrl = async (url, attempt = 0) => {

    try {
        if (!window.shouldVerifyUrl(window.location.hostname)) return false
        const response = await fetch(url, { method: "HEAD", mode: 'no-cors' });
        if (response.status !== 0) throw { status: 1 }
        return true
    }
    catch (e) {
        // console.log(e)
        // if (attempt >= 2)
        return e.status === 0
        // await new Promise(resolve => setTimeout(resolve, 1000))
        // return await verifyUrl(url, attempt + 1)
    }
}





const mapStateAsProps = state => ({
    report: state.projectInfo.report,
    isLatestReport: state.projectInfo.isLatestReport,
    recomputeReminderState: state.recomputeReminderState.shouldRecompute || state.projectInfo.report.areExclusionsDifferent,
    hasError: state.projectInfo.errorReport,
    reportTimestamp: state.projectInfo.report.timestamp,
    urlParams: state.projectInfo.urlParams,
    titleState: state.projectInfo.titleState,
    downloadKey: state.projectInfo.report.downloadKey,
    reportExclusions: state.projectInfo.report.exclusions,
    exclusions: state.projectInfo.exclusions,
    selectedBranch: state.projectInfo.urlParams.branch,
    branches: state.projectInfo.projectInfo.branches,
    displayBranches: state.projectInfo.projectInfo.branches ? state.projectInfo.projectInfo.branches.length > 0 : false,
    readonly: state.projectInfo.projectInfo.readonly,
    url: state.projectInfo.projectInfo.url,
    title: state.projectInfo.projectInfo.title,
    reportReady: state.projectInfo.reportReady,
    componentsCount: state.projectInfo.report.licensing ? state.projectInfo.report.licensing.componentsCount : 0,
    pi: state.projectInfo
})

export default connect(mapStateAsProps)(TitleRow);